import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { format } from "path";
import { Fetch } from "../../../shared/Fetch";
import { ILogin } from "../../../models/Login";

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
}

export const PendingTimesheetsList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const dt = useRef<any>(null);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

    const onHide = () => props.hideDialog();
    const header = () => <p></p>;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Timesheet/getLeftTimesheetDates", "POST", { PO_ID: props.singleData.pO_ID, FromDate: props.singleData.fromDate, ToDate: props.singleData.toDate }, null, null);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const DateFormat = loginObj?.date_Format;

    useEffect(() => {
        if (props.open && props.singleData.pO_ID) {
            loadTableData();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                ref={dt} size="small" stripedRows showGridlines
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
            </DataTable>
        </Dialog>
    );
}